export default __webpack_public_path__ + "static/media/educating@3x.9ce9e6c2.png";